import React from 'react';

import ReactMarkdown from 'react-markdown';

import {
    StyledBlockQuote,
    StyledH1,
    StyledH2,
    StyledH3,
    StyledH4,
    StyledH5,
    StyledH6,
    StyledImage,
    StyledLi,
    StyledLink,
    StyledOL,
    StyledP,
    StyledUL,
} from './styles';

interface StyledReactMarkdownProps {
    children: string;
    linkTarget?: '_blank' | '_self';
}
export const StyledReactMarkdown = ({ children, linkTarget }: StyledReactMarkdownProps) => {
    // TODO move to own file + add variants
    const general = {
        a: ({ node, ...props }) => <StyledLink target={linkTarget} {...props} />,
        p: ({ node, ...props }) => <StyledP {...props} />,
        img: ({ node, ...props }) => <StyledImage {...props} />,
        blockquote: ({ node, ...props }) => <StyledBlockQuote {...props} />,
    };

    const headings = {
        h1: ({ node, ...props }) => <StyledH1 {...props} />,
        h2: ({ node, ...props }) => <StyledH2 {...props} />,
        h3: ({ node, ...props }) => <StyledH3 {...props} />,
        h4: ({ node, ...props }) => <StyledH4 {...props} />,
        h5: ({ node, ...props }) => <StyledH5 {...props} />,
        h6: ({ node, ...props }) => <StyledH6 {...props} />,
    };

    const lists = {
        ol: ({ node, ...props }) => <StyledOL {...props} />,
        ul: ({ node, ...props }) => <StyledUL {...props} />,
        li: ({ node, ...props }) => <StyledLi {...props} />,
    };

    const components = { ...general, ...headings, ...lists };
    return (
        <ReactMarkdown linkTarget={linkTarget} components={components}>
            {children}
        </ReactMarkdown>
    );
};
